import { TXTWCL_Scroll_left, TXTWCL_Scroll_right } from './getAriaLabels.messages.json';

export const ariaLabelScrollLeft = TXTWCL_Scroll_left;
export const ariaLabelScrollRight = TXTWCL_Scroll_right;
